module.exports = __webpack_public_path__ + "static/media/popup-anapro.7caea0ad.png";